
import styled from 'styled-components'
import { devices } from '../../../../globalStyle'

export const GridContainer = styled.div `
    display: grid;
    grid-template-areas:
    "titleNew titleNew titleNew titleNew"
    "statusLabel status . ."
    "dateLabel date trackLabel track"
    "responsibleLabel responsible VehicleLabel Vehicle"
    ;
    gap: 1rem;
    border: 1px dashed #ccc; 
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    grid-template-rows: auto; 
    padding: 1.5rem 2rem; 
    flex-shrink: 0;
`

export const TableContainer = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: auto;
    padding: 0 1.5rem;
    margin-bottom: 0.5rem;

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #999;
    }
`

export const Container = styled.div`
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    max-height: 90vh;
    width: 80vw;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`
export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-right: 0.7vw;
    
`

export const HeaderText = styled.h1` 
font-family: 'Inter', sans-serif;
font-size: 2vw;
font-weight: 700;
margin-top: 0;
margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;
    
    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`
   
export const Text = styled.p` 
font-family: 'Inter', sans-serif;
font-size: 1rem;
font-weight: 700;
margin-top: 1rem;
margin-bottom: 0;
`

export const TextLabel = styled.p` 
font-family: 'Inter', sans-serif;
font-size: 1rem;
font-weight: 400;
margin-top: 1rem;
margin-bottom: 0;
color:  #303030;
`


export const OptionsDiv = styled.div `
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem 1.5rem;
    border-top: 1px solid #ebebeb;
    background-color: #fff;
    gap: 0.5rem;
`

export const ButtonOfSection = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 2.2vw;
  background-color: #0090d3;
  border-radius: 1vw;
  cursor: pointer;
  padding:.7vw;
  margin-right: 3vw;
  @media ${devices.largeDesktop} {
    width: 10vw;
  }

  &.reverse{
    background-color: #fff;
    border: 1px solid #0090d3;
  }
`

export const ButtonOfSectionText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  font-weight:700;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }

  &.reverse{
    color: #0090d3;
  }
`

export const IconImg = styled.img`
  display: flex;
  height: 1.3vw;
  margin-right: 0.5vw;
  margin-left: 0.5vw;

  @media ${devices.largeDesktop} {
    height: 1vw;
  }
`

export const LineDiv = styled.div`
    background: #EBEBEB;
    height: 0.1px;
    grid-area: line;
    
    margin-top: 0.5vw;
`

export const Table = styled.table`
  text-align: start;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 1rem;
`

export const DriverListDiv = styled.div`
position: absolute;
bottom: 100%;
right: 0;
margin-bottom: 0.5rem;
display: flex;
background-color: #fff;
padding: 0.5rem;
width: 14rem;
max-height: 12rem;
border: 1px solid #0090d3;
border-radius: 0.5rem;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
flex-direction: column;
align-items: center;
overflow-y: auto;
z-index: 10;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffffff; 
    border-radius: 3px; 
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0; 
    border-radius: 3px; 
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555555; 
  }
`

export const HeaderRow = styled.tr`
  height: 5vh;
`

export const ItemRow = styled.tr`
  height: 8vh;
  background-color: #ebebeb;
  box-sizing: border-box;
  font-weight: normal;
  &:hover {
    background-color: #F7F7F7;

    
    .edit-div {
      visibility: visible;
    }
    
  }
  border-bottom: 1px solid #d1d1d1; 
  
`

export const HeaderCell = styled.th`
  color: #696969;
  background-color: #fff;
  text-align: start;
  border: 0;
  font-size: 12px;
  font-weight: 600;
  padding: 0.75rem 1rem;
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 1px 0 #d1d1d1;
`

export const ItemCell = styled.td`
  text-align: start;
  font-size: 13px;
  padding: 0.8rem 1rem;
  color: #5c5c5c;
  border-bottom: px solid #5c5c5c;
  word-wrap: break-word;
  overflow-wrap: break-word;

  
  &:nth-child(1) { width: 5%;}  
  &:nth-child(2) { width: 10%; } 
  &:nth-child(3) { width: 20%; } 
  &:nth-child(4) { width: 5%; } 
  &:nth-child(5) { width: 40%; } 
  &:nth-child(6) { width: 20%; } 

  &.link {
    color: #0090d3;
    cursor: pointer;
  }
  a{
    color: #0090d3;
    cursor: pointer;
    text-decoration: none;
  }
`


export const ItemCellContainer = styled.div`
  display:flex;
  gap:0.3vw;
  align-items:center;

  .documentUrl {
    cursor:pointer;
    &:hover {
    color: #0090d3;
    }
  }
`
